/* eslint-disable no-param-reassign */
import { createSlice, createAction } from '@reduxjs/toolkit';

import initialState from '../../../domain/app/entities/generarDesafioTcoo';


// ---------------- Saga's response ----------------
function fetchGenerarTcooSuccess(state, action) {
  const { respuestaServicio } = action.payload;
  state.response = respuestaServicio;
  state.errorFetchConfirmar = false;
}

function fetchGenerarTcooError(state) {
  state.response = [];
  state.errorFetchConfirmar = true;
}


const fetchGenerarTcoo = createAction('fetchGenerarTcoo');

// ------------- connection ------------- //

const generarDesafioTcooReducer = createSlice({
  name: 'GenerarDesafioTcoo',
  initialState,
  reducers: {
    fetchGenerarTcooSuccess,
    fetchGenerarTcooError,
  },
});

export const generarDesafioTcooAction = {
  ...generarDesafioTcooReducer.actions,
  fetchGenerarTcoo,
};

export default generarDesafioTcooReducer.reducer;